import React, { Component } from 'react';
import Panel from '../../../../../../components/angle/Panel/index';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Select from '../../../../../../components/Select/index';

import {
    fetchAllClientInformationData,
    updateClientSelected
} from '../../../../../../services/redux/employee/clientInformation/actions';

class ClientListPanel extends Component {
    componentDidMount() {
        let { fetchAllClientInformationData } = this.props;
        fetchAllClientInformationData();
    }

    componentWillUnmount() {
        let { updateClientSelected } = this.props;
        updateClientSelected({});
    }

    handleClientChange = (name, value) => {
        let { updateClientSelected } = this.props;
        updateClientSelected({});
        if (value) {
            updateClientSelected(value);
        }
    };

    render() {
        let { clientInformation, buttons } = this.props;
        return (
            <Panel
                showHeader
                header="Clients"
                showFooter
                footerComponents={buttons}
            >
                <div>
                    <Select
                        name="clientId"
                        labelKey="name"
                        valueKey="clientId"
                        placeholder="Choose a Client"
                        selectedValue={
                            clientInformation.selectedItemData.clientId
                        }
                        onChange={this.handleClientChange}
                        options={clientInformation.clients}
                    />
                </div>
            </Panel>
        );
    }
}

const mapStateToProps = state => ({
    clientInformation: state.employee.clientInformation
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchAllClientInformationData,
            updateClientSelected
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ClientListPanel));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/ClientInformation/screens/SearchClient/ClientListPanel.js